import { FormControlLabel, Radio, Tooltip } from '@mui/material'
import { FormattedMessage } from 'react-intl'

export function ConnectionShareViewerCredentials({ disabled, tooltip }) {
  return (
    <Tooltip title={disabled && tooltip}>
      <FormControlLabel
        value="viewer"
        control={<Radio disabled={disabled} color="primary" />}
        label={<FormattedMessage id={'common.shareDialog.sharingMode.viewerCredentials'} />}
      />
    </Tooltip>
  )
}

export default ConnectionShareViewerCredentials
